import { render, staticRenderFns } from "./PanelAccountSettingsPayments.vue?vue&type=template&id=022c9a5a&scoped=true&"
import script from "./PanelAccountSettingsPayments.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsPayments.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsPayments.vue?vue&type=style&index=0&id=022c9a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c9a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022c9a5a')) {
      api.createRecord('022c9a5a', component.options)
    } else {
      api.reload('022c9a5a', component.options)
    }
    module.hot.accept("./PanelAccountSettingsPayments.vue?vue&type=template&id=022c9a5a&scoped=true&", function () {
      api.rerender('022c9a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAccountSettingsPayments.vue"
export default component.exports